import { useState } from "react";
import HomepageFooter from "@/components/homepage/HomepageFooter";
import HomepageLeadModal from "@/components/homepage/HomepageLeadModal";
import HomepageStickyCta from "@/components/homepage/HomepageStickyCta";
import Navbar from "@/components/homepage/Navbar";
import Archive from "@/components/daily-ai-updates/Archive";
import DailyAIUpdatesHero from "@/components/daily-ai-updates/Hero";

const DailyAIUpdates = () => {
  const [leadModal, setLeadModal] = useState<{ open: boolean; email: string }>({
    open: false,
    email: "",
  });

  const openLeadModal = (email: string) => {
    setLeadModal({ open: true, email });
  };

  const closeLeadModal = () => {
    setLeadModal({ open: false, email: "" });
  };

  return (
    <main
      className="flex min-h-svh w-full flex-col bg-black pb-24 text-white max-md:pb-[calc(5rem+env(safe-area-inset-bottom,0px))]"
      style={{ fontFamily: "var(--font-fira)" }}
    >
      <Navbar />
      <DailyAIUpdatesHero onEmailContinue={openLeadModal} />
      <Archive />
      <HomepageFooter onEmailContinue={openLeadModal} />
      <HomepageStickyCta
        heroSectionId="daily-ai-updates-hero"
        ctaSectionId="homepage-cta"
        marketingBasePath="/daily-ai-updates"
        onEmailContinue={openLeadModal}
      />
      <HomepageLeadModal
        open={leadModal.open}
        initialEmail={leadModal.email}
        onClose={closeLeadModal}
      />
    </main>
  );
};

export default DailyAIUpdates;
